<template>
  <div class="flex flex-col h-full">
    <div class="grow px-5 pt-5 overflow-y-auto leading-8">
      <div class="pb-2" style="width: 100%;">
        <a>联动表单</a>
      </div>
      <div
        class="w-full mb-5"
        style="height: 32px; line-height: 30px;"
      >
        <el-select v-model="rely.data.formId" size="small" style="width: 100%;" @change="onFormChange">
          <el-option v-for="_form in form" :key="_form.id" :value="_form.id" :label="_form.name" />
        </el-select>
      </div>
      <div>
        满足以下所有条件时
      </div>
      <div v-for="(cond, index) in rely.filter.cond" :key="index" class="flex leading-8 py-1">
        <div class="flex grow justify-between flex-row">
          <div class="w-1/2 justify-between flex">
            <div class="w-1/2 h-8 flex items-center">
              <el-select v-model="cond.field" size="mini">
                <el-option v-for="field in relyFields" :key="field.name" :label="field.text" :value="field.name" />
              </el-select>
            </div>
            <div class="mx-2 w-1/2 m-auto flex justify-center method">
              <el-dropdown trigger="click" @command="cond.method=$event">
                <span class="el-dropdown-link">
                  {{ getMethodName(cond.method) }}<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="method in methods" :key="method.value" :command="method.value">{{ method.name }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="w-1/2">
            <div class="fui_dept_check">
              <el-select v-model="cond.depend_field" style="width: 100%;" size="mini" placeholder="请选择">
                <el-option v-for="field in widgets" :key="field.key" :label="field.name" :value="field.key" />
              </el-select>
            </div>
          </div>
        </div>

        <i class="bi bi-trash w-4 px-2 cursor-pointer" @click="onDelete(index)" />
      </div>
      <div>
        <span class="cursor-pointer text-sky-500 text-sm h-9 leading-9" @click="handleSelect">
          <i class="bi bi-plus text-base" />
          添加条件
        </span>
      </div>
      <div class="x-label visible_field_label pt-10 pb-2" style="width: 100%;">
        <a>触发以下联动</a>
      </div>
      <div class="flex leading-8 py-1">
        <div class="flex grow justify-between flex-row">
          <div class="w-1/2 justify-between flex">
            <div class="border w-2/3 h-8 rounded flex items-center">{{ data.name }}</div>
            <div class="mx-2 w-1/3 m-auto flex justify-center method">
              联动显示
            </div>
          </div>
          <div class="w-1/2">
            <div class="fui_dept_check">
              <el-select v-model="rely.data.field" style="width: 100%;" size="mini" placeholder="请选择">
                <el-option v-for="field in relyFields" :key="field.name" :label="field.text" :value="field.name" />
              </el-select>
            </div>
          </div>
        </div>

        的值
      </div>
    </div>
    <div class="h-15 border-t py-[14px] px-5 text-right">
      <el-button type="primary" @click="onConfirm">确定</el-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import zroute from '../ziggy'

export default {
  name: 'DataRely',
  props: {
    widgets: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({
        data: {field:'', formId:''},
        filter: {rel: 'and', cond: []},
      }),
    },
  },
  data() {
    return {
      form_id: zroute().params.form_id,
      app_id: zroute().params.app_id,
      form: [],
      // rely: {
      //   'filter': {
      //     'rel': 'and',
      //     'cond': [
      //       {
      //         'method': 'eq',
      //         'field': '_widget_1654676916151',
      //         'type': 'user',
      //         'mode': 'depend',
      //         'value': null,
      //         'depend': {
      //           'field': '_widget_1654677080260',
      //         },
      //       },
      //     ],
      //   },
      //   'data': {
      //     'formId': '62a05db3431e460008443d0f',
      //     'field': '_widget_1654676916108',
      //   },
      // },
      rely: _.cloneDeep(this.value),
      rels: [{name: '所有', value: 'and'}, {name: '任一', value: 'or'}],
      methods: [
        {name: '等于', value: 'eq', type: ['input', 'date']},
        {name: '不等于', value: 'neq', type: ['input']},
        {name: '大于等于', value: 'gte', type: ['date']},
        {name: '小于等于', value: 'lte', type: ['date']},
        {name: '选择范围', value: 'range', type: ['date']},
        {name: '动态筛选', value: 'formula', type: ['date']},
        {name: '等于任意一个', value: 'in', type: ['input']},
        {name: '不等于任意一个', value: 'nin', type: ['input']},
        {name: '为空', value: 'empty', type: ['input']},
        {name: '不为空', value: 'not_empty', type: ['input']},
      ],
      text: '',
      addRuleVisible: false,
      visible: false,
    }
  },
  computed: {
    relyFields() {
      if (this.rely.data.formId === '' || this.form.length === 0) {
        return []
      }
      return this.form.find(item => item.id === this.rely.data.formId).fields
    },
  },
  created() {
    console.log('datarely created', this.value)
    this.getFields()
  },
  methods: {
    onFormChange() {
      this.rely.filter.cond = []
      this.rely.data.field = ''
    },
    onConfirm() {
      this.rely.data.formType = this.form.find(item => item.id === this.rely.data.formId).type
      this.$emit('input', this.rely)
    },
    onDelete(index) {
      this.rely.filter.cond.splice(index, 1)
    },
    getWidgetType(key) {
      return this.widgets.find(item => item.key === key).type
    },
    getWidgetName(key) {
      return this.widgets.find(item => item.key === key).name
    },
    getRelName(val) {
      return this.rels.find(item => item.value === val).name
    },
    getMethodName(val) {
      return this.methods.find(item => item.value === val).name
    },
    handleSelect() {
      this.rely.filter.cond.push({
        field: '',
        method: 'eq',
        value: [],
      })
    },
    getFields() {
      axios.get(zroute('app.form.fields', {app_id: this.app_id, form_id: this.form_id})).then(res => {
        this.form = res.data.form
      })
    },
  },
}
</script>

<style scoped>

</style>
